module.exports = __webpack_public_path__ + "img/sunshine-page_900.46d22282.png";